// frontend/src/PaypalPayment.js
import React, { useEffect, useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { useNavigate } from 'react-router-dom';
import './PaypalPayment.css'


const PaypalPayment = () => {
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    const storedPayment = localStorage.getItem('pendingPayment');
    if (storedPayment) {
      setPaymentData(JSON.parse(storedPayment));
    } else {
      alert('No pending payment found!');
      navigate('/dashboard');
    }
  }, [navigate]);

  if (!paymentData) return null;

  const handleApprove = async (details) => {
    try {
      // Send payment confirmation to backend
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/payments/paypal-webhook/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(details),
      });

      alert('Payment successful! Your service request is confirmed.');
      localStorage.removeItem('pendingPayment');
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      alert('Payment succeeded, but there was a server issue. Contact support.');
    }
  };

  return (
    <div className="paypal-payment-container">
      <h1>PayPal Payment</h1>
      <p>Amount: KES {paymentData.amount}</p>
      <p>Description: {paymentData.description}</p>

      <PayPalScriptProvider
        options={{
          "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
          currency: paymentData.currency || 'KES',
          intent: 'capture',
        }}
      >
        <PayPalButtons
          style={{ layout: 'vertical', color: 'blue', shape: 'rect', label: 'paypal' }}
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: paymentData.amount.toString(),
                    currency_code: paymentData.currency || 'KES',
                  },
                  description: paymentData.description,
                  custom_id: paymentData.metadata?.submissionId || '',
                },
              ],
            });
          }}
          onApprove={async (data, actions) => {
            const details = await actions.order.capture();
            console.log('PayPal Payment Details:', details);
            await handleApprove(details);
          }}
          onError={(err) => {
            console.error('PayPal Payment Error:', err);
            alert('Payment could not be completed. Please try again.');
          }}
          onCancel={() => {
            alert('Payment cancelled.');
          }}
        />
      </PayPalScriptProvider>
    </div>
  );
};

export default PaypalPayment;
